import { Config } from "@/config";
import axios from "axios";
import { authHeader } from "@/helpers/auth-header";
import { handleAxiosError } from "@/services/axiosErrorHandler";
import stringify = Mocha.utils.stringify;

function upload(
  submission: {
    method: string;
    description: string;
    challenge: string;
    trainingData: Array<string>;
    task: string;
    file: string;
    personalData: boolean;
    publication: any;
    modelWeights: string;
  },
  callback: (loaded: number, total: number) => void
) {
  /**
   * submission: object containing the following fields:
   *   {method, description,challenge,task,file}
   * callback:
   *   callback function used to update progress
   */
  const formData = new FormData();
  formData.append("method", submission.method);
  formData.append("description", submission.description);
  formData.append("challenge", submission.challenge);
  formData.append("task", submission.task);
  formData.append("file", submission.file);
  formData.append("trainingData", JSON.stringify(submission.trainingData));
  formData.append(
    "meta",
    JSON.stringify({
      publication: submission.publication,
      personalData: submission.personalData
    })
  );

  if (submission.modelWeights)
    formData.append("modelWeights", submission.modelWeights);

  /*
    Make the request to the POST /single-file URL
  */
  return axios
    .post(Config.apiUrl + "/upload", formData, {
      headers: authHeader(),
      onUploadProgress: event => callback(event.loaded, event.total)
    })
    .then(resp => Promise.resolve(resp.data))
    .catch(handleAxiosError);
}

function uploadSubmissionModel(submissionId: string, file: string, callback: (loaded: number, total: number) => void) {
  const formData = new FormData();
  formData.append("modelWeights", file);
  formData.append("submissionId", submissionId);

  /*
    Make the request to the POST /single-file URL
  */
  return axios
    .post(Config.apiUrl + "/uploadSubmissionWeights", formData, {
      headers: authHeader(),
      onUploadProgress: event => callback(event.loaded, event.total)
    })
    .then(resp => Promise.resolve(resp.data))
    .catch(handleAxiosError);
}

function downloadSubmissionModel(submissionId: string, fileName: string) {
  /**
    Downloads a file with given file id and stores ith with the given fileName
   */
  return axios({
    url: `${Config.apiUrl}/getModelUri/${submissionId}`,
    method: "GET",
    responseType: "json",
    headers: authHeader()
  })
    .then(resp => {
      // @ts-ignore
      const token = resp.data.token;
      const filePath = `${Config.apiUrl}/downloadModelWeights/${token}/${fileName}`;
      const a = document.createElement("A") as any;
      a.href = filePath;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
    .catch(handleAxiosError);
}

function download(fileId: string, fileName: string) {
  /**
    Downloads a file with given file id and stores ith with the given fileName
   */
  return axios({
    url: `${Config.apiUrl}/getPackageUri/${fileId}`,
    method: "GET",
    responseType: "json",
    headers: authHeader()
  })
    .then(resp => {
      // @ts-ignore
      const token = resp.data.token;
      const filePath = `${Config.apiUrl}/downloadPackage/${token}/${fileName}`;
      const a = document.createElement("A") as any;
      a.href = filePath;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
    .catch(handleAxiosError);
}

export const filehandlingService = {
  download,
  downloadSubmissionModel,
  uploadSubmissionModel,
  upload
};
